import React, { useState, useEffect } from "react";
import MUIDataTable from "mui-datatables";
import axios from "axios";
import { toast } from "react-toastify";
import { CircularProgress, Hidden } from "@material-ui/core";

import Swal from "sweetalert2";
import AdminLayout from "../AdminLayout";
import AddIcon from "@material-ui/icons/Add";
import {
  AppBar,
  Dialog,
  IconButton,
  Rating,
  Slide,
  Toolbar,
  Tooltip,
} from "@mui/material";
import { generateForm } from "src/helpers/functions";
import SingleCustomAutocomplete from "src/Components/CustomAutocomplete/SingleCustomAutocomplete";
import dayjs from "dayjs";
import CustomFilter from "./CustomFilter";
import CustomToolbarFilter from "src/Components/CustomToolbar/CustomToolbarFilter";
import { useLocation, useNavigate } from "react-router-dom";
import CustomMuiDataTable from "src/Components/CustomMuiDataTable";
import JobUpdateModal from '../../../Components/JobUpdateModal';
import StatusAddUpdateForm from "src/Components/AdminJobs/StatusAddUpdateForm";
import PaymentAddUpdateForm from "src/Components/AdminJobs/PaymentAddUpdateForm";
import WorkerProfileDialog from "src/Components/AdminJobs/WorkerProfileDialog";
import StatusDialog from "src/Components/AdminJobs/StatusDialog";
import PaymentsDialog from "src/Components/AdminJobs/PaymentsDialog";
import JobsTable from "src/Components/AdminJobs/JobsTable";

const AdminJobs = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { id: state_id, type: state_type } = location.state ?? {};
  
  // Also check URL query parameters for when opening in new tab
  const urlParams = new URLSearchParams(location.search);
  const url_id = urlParams.get('id');
  const url_type = urlParams.get('type');
  
  // Use URL params if state is not available
  const job_id = state_id || url_id;
  const job_type = state_type || url_type;

  const [data, setData] = useState([]);
  const [visible, setVisible] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [id, setId] = useState(-1);
  const [paymentType, setPaymentType] = useState("");
  const [statusData, setStatusData] = useState([]);
  const [statusVisible, setStatusVisible] = useState(false);

  const [paymentsData, setPaymentsData] = useState([]);
  const [paymentsVisible, setPaymentsVisible] = useState(false);

  const [addUpdatePaymentVisible, setAddUpdatePaymentVisible] = useState(false);

  const defaultFromDate = dayjs().subtract(5, 'day').toDate();
  const defaultToDate = new Date();

  const [filterForm, setFilterForm] = useState({
    fromDate: defaultFromDate,
    toDate: defaultToDate,
  });

  const handleclear = () => {
    setFilterForm({
      fromDate: defaultFromDate,
      toDate: defaultToDate,
    });
  };

  const handleCloseStatusModal = () => {
    setStatusVisible(false);
    getData();
  };

  const handleClosePaymentsModal = () => {
    setPaymentsVisible(false);
    getData();
  };
  const loadStatuses = (meta) => {
    const metaId = meta ? meta.rowData[0] : id;
    setId(metaId);
    axios({
      method: "get",
      url: `${process.env.REACT_APP_API}/admin/jobs/getStatuses/${metaId}`,
    })
      .then((response) => {
        setStatusData(response.data);
        if (meta) setStatusVisible(true);
      })
      .catch((error) => {
        toast.error(`Error`);
      });
  };

  const loadPayments = (meta, type) => {
    const metaId = meta ? meta.rowData[0] : id;
    setId(metaId);
    setPaymentType(type);
    axios
      .get(`${process.env.REACT_APP_API}/admin/jobs/getPayments`, {
        params: {
          id: metaId,
          type: type,
        },
      })
      .then((response) => {
        setPaymentsData(response.data);
        if (meta) setPaymentsVisible(true);
      })
      .catch((error) => {
        toast.error(`Error`);
      });
  };

  const handleChangeInputFilter = (event) => {
    const { id, value, checked, type } = event.target;
    if (type == "checkbox") {
      setFilterForm((prev) => ({
        ...prev,
        [id]: checked,
      }));
    } else {
      setFilterForm((prev) => ({
        ...prev,
        [id]: value,
      }));
    }
  };

  const [venders, setVenders] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [jobTypes, setJobTypes] = useState([]);

  const getVenders = () => {
    axios
      .get(`${process.env.REACT_APP_API}/admin/users/getVenders`, {})
      .then(function (response) {
        setVenders(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const getCustomers = () => {
    axios
      .get(`${process.env.REACT_APP_API}/admin/users/getCustomers`, {})
      .then(function (response) {
        setCustomers(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const getJobTypes = () => {
    axios
      .get(`${process.env.REACT_APP_API}/admin/users/getJobTypes`, {})
      .then(function (response) {
        setJobTypes(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const getData = () => {
    setIsLoading(true);
    axios
      .get(`${process.env.REACT_APP_API}/admin/jobs/get`, {
        params: {
          fromDate: filterForm.fromDate,
          toDate: filterForm.toDate,
        },
      })
      .then(function (response) {
        setData(response.data);

        setIsLoading(false);
      })
      .catch(function (error) {
        setIsLoading(false);
        toast("Error", {
          position: "top-right",
          type: "error",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
        console.log(error);
      });
  };

  const [updateJobLoading, setUpdateJobLoading] = useState(false);

  const saveJobForm = () => {
    setUpdateJobLoading(true);
    if (jobFormData.id > 0) {
      const submitFormData = generateForm({
        ...jobFormData,
        why_no_deal:
          jobFormData.why_no_deal === "Other"
            ? jobFormData.why_no_deal_other
            : jobFormData.why_no_deal,
      });

      axios({
        method: "post",
        url: `${process.env.REACT_APP_API}/admin/jobs/update`,
        data: submitFormData,
      })
        .then((response) => {
          toast.success(`Updated successfully`);
          setUpdateJobLoading(false);
          setUpdateJobVisible(false);
          setVisible(false);
          getData();
        })
        .catch((error) => {
          setUpdateJobLoading(false);
          toast.error(`Error While Saving`);
        });
    } else {
      const submitFormData = generateForm(jobFormData);

      axios({
        method: "post",
        accept: "any",
        url: `${process.env.REACT_APP_API}/admin/jobs/add`,
        data: submitFormData,
      })
        .then((response) => {
          //setCurrentId(response.data.serial)
          toast.success(`Inserted successfully`);
          setUpdateJobLoading(false);
          setUpdateJobVisible(false);

          getData();
        })
        .catch((error) => {
          setUpdateJobLoading(false);
          toast.error(`Error While Saving`);
        });
    }
  };

  const [updateJobVisible, setUpdateJobVisible] = useState(false);
  const [selectedJobId, setSelectedJobId] = useState(-1);

  const [jobFormData, setJobFormData] = useState({
    user_id: null,
    customer_id: null,
    no_deal_handyman_id: null,
    why_no_deal: "",
    why_no_deal_other: "",
    job_type: null,
    another_quotation: null,
    priority: null,
    description: "",
    gift: "",
    review_rate: "",
    review_text: "",
    // testimonial: 0,
    start_date: null,
    end_date: null,
    review: 0,
    gift_sent: 0,
    job_accepted: 0,
    id: -1,
  });


  const resetJobForm = () => {
    setJobFormData({
      user_id: null,
      customer_id: null,
      no_deal_handyman_id: null,
      why_no_deal: "",
      why_no_deal_other: "",
      job_type: null,
      another_quotation: null,
      priority: null,
      description: "",
      gift: "",
      review_rate: "",
      review_text: "",
      // testimonial: 0,
      start_date: null,
      end_date: null,
      review: 0,
      gift_sent: 0,
      job_accepted: 0,
      id: -1,
    });
  };

  const handleCloseUpdateJob = () => {
    setUpdateJobVisible(false);
  };

  const addJob = () => {
    setSelectedJobId(-1); // -1 means add mode
    setUpdateJobVisible(true);
  };

  const updateJob = (meta) => {
    const id = meta.rowData[0];
    setSelectedJobId(id); // actual ID means update mode
    setUpdateJobVisible(true);
    
    // Update URL to include the job ID parameter
    navigate(`/admin/jobs?id=${id}&type=job`, { replace: true });
  };


  const updateColor = (meta, updateValue) => {
    const id = meta.rowData[0];
    setSelectedJobId(id);

    // Show confirmation dialog
    Swal.fire({
      title: "Please Confirm Your Action !",
      confirmButtonText: "Apply",
      showCancelButton: true,
      icon: "warning",
    }).then((result) => {
      if (result.isConfirmed) {
        setIsLoading(true);
        axios
          .post(`${process.env.REACT_APP_API}/admin/jobs/updatePriority/${id}`)
          .then((response) => {
            const newPriority = response.data.priority;
            let backgroundColor = "transparent";
            if (newPriority === 1) {
              backgroundColor = "red";
            } else if (newPriority === 2) {
              backgroundColor = "yellow";
            }

            updateValue(newPriority);
            getData();
            setIsLoading(false);
            toast.success("Priority updated successfully");
          })
          .catch(() => {
            toast.error("Error updating priority");
            setIsLoading(false);
          });
      }
    });
  };


  const deleteForm = (meta) => {
    const id = meta.rowData[0];
    Swal.fire({
      title: "Please Confirm Your Action ?",
      showCancelButton: true,
      confirmButtonText: "Delete",
      icon: "warning",
    }).then((result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {
        axios({
          method: "post",
          url: `${process.env.REACT_APP_API}/admin/jobs/delete`,
          data: { id: id },
        })
          .then((response) => {
            toast.success(`Success`);
            getData();
          })
          .catch((error) => {
            toast.error(`Error`);
          });
      }
    });
  };

  const handleClose = () => {
    setVisible(false);
    loadStatuses(null);
  };

  const handleCloseAddUpdatePayment = () => {
    setPaymentId(-1);
    setAddUpdatePaymentVisible(false);
  };

  const toggleTestimonial = (meta) => {
    const id = meta.rowData[0];
    Swal.fire({
      title: "Please Confirm Your Action ?",
      showCancelButton: true,
      confirmButtonText: "YES",
      icon: "warning",
    }).then((result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {
        axios({
          method: "post",
          url: `${process.env.REACT_APP_API}/admin/jobs/testimonial`,
          data: { id: id },
        })
          .then((response) => {
            toast.success(`Success`);
            getData();
          })
          .catch((error) => {
            toast.error(`Error`);
          });
      }
    });
  };

  const getCategories = () => {
    axios
      .get(`${process.env.REACT_APP_API}/noAuthApi/getCategories`)
      .then(function (response) {
        const all = response.data;

        setCategories(all);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const [visibleWorker, setVisibleWorker] = useState(false);
  const [formData, setFormData] = useState({});
  const [categories, setCategories] = useState([]);
  const [selectedcategories, setselectedCategories] = useState([]);

  const handleCloseWorker = () => {
    setVisibleWorker(false);
  };

  const checkWorker = (userId) => {
    axios({
      method: "get",
      url: `${process.env.REACT_APP_API}/admin/users/getById/${userId}`,
    })
      .then((response) => {
        const categoriesArr = response.data.categories.split(",");

        const selectedcategoriesArr = [];
        categoriesArr?.map((item) => {
          let found = categories.find(
            (data) => parseInt(data.category.id) == parseInt(item)
          );
          if (found) {
            selectedcategoriesArr.push(found.category);
          }
        });
        console.log(
          "selectedcategoriesArr",
          categoriesArr,
          selectedcategoriesArr
        );
        setselectedCategories(selectedcategoriesArr);

        setFormData(response.data);

        setVisibleWorker(true);
      })
      .catch((error) => {
        toast.error(`Error`);
      });
  };

  const columns = [
    {
      name: "id",
      label: "ID",
    },

    {
      name: "user_id",
      label: "Worker Id",
      options: {
        display: false,
      },
    },

    {
      name: "user_name",
      label: "Worker name",

      options: {
        customBodyRender: (value, meta) => {
          return (
            <span
              style={{ cursor: "pointer" }}
              onClick={() => checkWorker(meta.rowData[1])}
            >
              {" "}
              {value}
            </span>
          );
        },
      },
    },
    {
      name: "job_name",
      label: "Job Category",
    },
    {
      name: "customer_name",
      label: "Customer name",
    },
    {
      name: "customer_phone",
      label: "Customer Phone",
    },
    {
      name: "customer_email",
      label: "Customer Email",
    },
    {
      name: "description",
      label: "Special Notes",
    },
    {
      name: "status_name",
      label: "Status",
      options: {
        customBodyRender: (value) => {
          return <span>{value ? value : "pending..."}</span>;
        },
      },
    },
    {
      name: "priority",
      label: "priority",
    },
    {
      name: "status_description",
      label: "Note",
      options: {
        customBodyRender: (value, tableMeta, updateValue) => {
          const priority = parseInt(tableMeta.rowData[9], 10);
          let backgroundColor = "transparent";

          if (priority === 1) {
            backgroundColor = "red";
          } else if (priority === 2) {
            backgroundColor = "yellow";
          }

          return (
            <span
              style={{
                backgroundColor,
                padding: "5px",
                borderRadius: "3px",
                display: "inline-block",
                minWidth: "50%",
                minHeight: "40px",
                cursor:
                  priority === 1 || priority === 2 ? "pointer" : "default",
              }}
              onClick={() => {
                if (priority === 1 || priority === 2) {
                  updateColor(tableMeta, updateValue);
                }
              }}
            >
              {value || "             "}{" "}
            </span>
          );
        },
      },
    },

    {
      name: "created_at",
      label: "Date",
    },
    {
      name: "paidClientAmount",
      label: "paidClientAmount",
      options: {
        display: false,
      },
    },
    {
      name: "client_amount",
      label: "From Client",

      options: {
        customBodyRender: (value, meta) => {
          const paidAmount = meta.rowData[12] ?? 0;
          const totalAmount = value ?? 0;

          const isEqual = Number(paidAmount) === Number(totalAmount);
          const color = isEqual ? "green" : "red";

          return (
            <span style={{ color }}>{`${paidAmount}/${totalAmount}`}</span>
          );
        },
      },
    },
    {
      name: "paidWorkerAmount",
      label: "paidWorkerAmount",
      options: {
        display: false,
      },
    },
    {
      name: "worker_amount",
      label: "To Worker",
      options: {
        customBodyRender: (value, meta) => {
          const paidAmount = meta.rowData[14] ?? 0;
          const totalAmount = value ?? 0;

          const isEqual = Number(paidAmount) === Number(totalAmount);
          const color = isEqual ? "green" : "red";

          return (
            <span style={{ color }}>{`${paidAmount}/${totalAmount}`}</span>
          );
        },
      },
    },
    {
      name: "profit",
      label: "Profit",
    },
    {
      name: "why_no_deal",
      label: "Why No Deal",
      options: {
        display: false,
      },
    },
    {
      name: "no_deal_handyman_name",
      label: "No Deal Handyman Name",
      options: {
        display: false,
      },
    },
    {
      name: "another_quotation",
      label: "Another Quotation",
      options: {
        customBodyRender: (value, meta) => {
          const rowData = meta.rowData;
          const anotherQuotation = rowData[19];
          const handymanName = rowData[18];
          const reason = rowData[17];

          return (
            <div style={{ whiteSpace: "pre-line" }}>
              {/* <div>{anotherQuotation}</div> */}
              <div>{handymanName}</div>
              <div>{reason}</div>
            </div>
          );
        },
      },
    },
    {
      name: "actions",
      label: "Actions",
      options: {
        filter: false,
        sort: false,
        empty: true,
        customBodyRender: (value, meta) => {
          return (
            <button
              className="btn btn-primary mx-1"
              onClick={() => {
                updateJob(meta);
              }}
            >
              Update
            </button>
          );
        },
      },
    },

    {
      name: "reviewed",
      label: "Reviewed",
      options: {
        customBodyRender: (value) => {
          return (
            <input
              disabled
              className="form-check-input"
              type="checkbox"
              readOnly
              checked={value == 1 ? true : false}
            />
          );
        },
      },
    },

    {
      name: "review_rate",
      label: "Rating",
      options: {
        customBodyRender: (value) => {
          return value ? (
            <Rating size="large" id="stars" readOnly value={value} />
          ) : (
            <></>
          );
        },
      },
    },

    {
      name: "review_text",
      label: "Review",
    },

    {
      name: "review",
      label: "Show in Reviews",
      options: {
        customBodyRender: (value) => {
          return (
            <input
              disabled
              className="form-check-input"
              type="checkbox"
              readOnly
              checked={value == 1 ? true : false}
            />
          );
        },
      },
    },
    {
      name: "job_accepted",
      label: "Job Accepted",
      options: {
        customBodyRender: (value) => {
          return (
            <input
              disabled
              className="form-check-input"
              type="checkbox"
              readOnly
              checked={value == 1 ? true : false}
            />
          );
        },
      },
    },
    {
      name: "gift_sent",
      label: "Gift Sent",
      options: {
        customBodyRender: (value) => {
          return (
            <input
              disabled
              className="form-check-input"
              type="checkbox"
              readOnly
              checked={value == 1 ? true : false}
            />
          );
        },
      },
    },
    {
      name: "gift",
      label: "Gift",
    },
  ];

  const options = {
    tableBodyHeight: "75vh",
    filter: true,
    rowsPerPage: 50,
    rowsPerPageOptions: [20, 50, 100],
    selectableRows: "none",
    draggableColumns: {
      enabled: true, // Enable column reordering
    },
    customToolbar: () => {
      return (
        <span>
          <CustomToolbarFilter filterListener={filterListener} />

          <Tooltip title={"Add"}>
            <IconButton onClick={addJob}>
              <AddIcon />
            </IconButton>
          </Tooltip>
        </span>
      );
    },

    textLabels: {
      body: {
        noMatch: isLoading ? (
          <CircularProgress />
        ) : (
          "There is no matching data to display"
        ),
      },
    },
  };

  useEffect(() => {
    getData();

    if (venders.length == 0) getVenders();
    if (customers.length == 0) getCustomers();
    if (jobTypes.length == 0) getJobTypes();
    if (categories.length == 0) getCategories();

    if (job_id && job_type) {
      let meta = { rowData: [job_id] };

      if (job_type == "job") {
        updateJob(meta);
      }

      if (job_type == "statuses") {
        loadStatuses(meta);
      }

      if (job_type == "payments") {
        loadPayments(meta);
      }
    }
  }, []);

  const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
  });

  const deleteStatus = (meta) => {
    const id = meta.rowData[0];
    Swal.fire({
      title: "Please Confirm Your Action ?",
      showCancelButton: true,
      confirmButtonText: "Delete",
      icon: "warning",
    }).then((result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {
        axios({
          method: "post",
          url: `${process.env.REACT_APP_API}/admin/jobs/status/delete`,
          data: { id: id },
        })
          .then((response) => {
            toast.success(`Success`);
            loadStatuses(null);
          })
          .catch((error) => {
            toast.error(`Error`);
          });
      }
    });
  };

  const deletePayment = (meta) => {
    const id = meta.rowData[0];
    Swal.fire({
      title: "Please Confirm Your Action ?",
      showCancelButton: true,
      confirmButtonText: "Delete",
      icon: "warning",
    }).then((result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {
        axios({
          method: "post",
          url: `${process.env.REACT_APP_API}/admin/jobs/payments/delete`,
          data: { id: id },
        })
          .then((response) => {
            toast.success(`Success`);
            loadStatuses(null);
          })
          .catch((error) => {
            toast.error(`Error`);
          });
      }
    });
  };

  const [paymentId, setPaymentId] = useState(-1);

  const updatePayment = (meta) => {
    resetJobForm();
    const id = meta.rowData[0];
    setPaymentId(id);

    setAddUpdatePaymentVisible(true);
  };

  const statusColumns = [
    {
      name: "id",
      label: "ID",
    },
    {
      name: "status",
      label: "Status",
    },
    {
      name: "date",
      label: "Follow Up Date",
    },
    {
      name: "description",
      label: "Description",
    },
    {
      name: "created_at",
      label: "Created",
    },
    {
      name: "actions",
      label: "Actions",
      options: {
        filter: false,
        sort: false,
        empty: true,
        customBodyRender: (value, meta) => {
          return (
            <div>
              <button
                className="btn btn-danger mx-1"
                onClick={() => {
                  deleteStatus(meta);
                }}
              >
                Delete
              </button>
            </div>
          );
        },
      },
    },
  ];
  const payments = ["Cash", "Whish", "OMT", "Bank Transfer"];
  const paymentsColumns = [
    {
      name: "id",
      label: "ID",
    },
    {
      name: "amount",
      label: "Amount",
    },
    {
      name: "due_date",
      label: "Date",
    },
    {
      name: "type",
      label: "Type",
      options: {
        customBodyRender: (value) => {
          return value ? (
            <>{value == "in" ? "From Client" : "To Worker"}</>
          ) : (
            <></>
          );
        },
      },
    },

    {
      name: "paid",
      label: "paid",
      options: {
        customBodyRender: (value) => {
          return (
            <input
              disabled
              className="form-check-input"
              type="checkbox"
              readOnly
              checked={value == 1 ? true : false}
            />
          );
        },
      },
    },
    {
      name: "paid",
      label: "paid",
      options: {
        customBodyRender: (value) => (value ? payments[value - 1] : ""),
      },
    },
    {
      name: "actions",
      label: "Actions",
      options: {
        filter: false,
        sort: false,
        empty: true,
        customBodyRender: (value, meta) => {
          return (
            <div>
              <button
                className="btn btn-info mx-1"
                onClick={() => {
                  updatePayment(meta);
                }}
              >
                Update
              </button>
              <button
                className="btn btn-danger mx-1"
                onClick={() => {
                  deletePayment(meta);
                }}
              >
                Delete
              </button>
            </div>
          );
        },
      },
    },
  ];
  const addStatus = () => {
    setVisible(true);
  };

  const addPayment = (type = null) => {
    setPaymentType(null);
    setPaymentId(-1);

    setAddUpdatePaymentVisible(true);
  };

  const statusOptions = {
    filter: true,
    rowsPerPage: 50,
    rowsPerPageOptions: [20, 50, 100],
    selectableRows: "none",

    customToolbar: () => {
      return (
        <span>
          <Tooltip title={"Add"}>
            <IconButton onClick={addStatus}>
              <AddIcon />
            </IconButton>
          </Tooltip>
        </span>
      );
    },

    textLabels: {
      body: {
        noMatch: isLoading ? (
          <CircularProgress />
        ) : (
          "There is no matching data to display"
        ),
      },
    },
  };

  const paymentsOptions = {
    filter: true,
    rowsPerPage: 50,
    rowsPerPageOptions: [20, 50, 100],
    selectableRows: "none",

    customToolbar: () => {
      return (
        <span>
          <Tooltip title={"Add"}>
            <IconButton onClick={addPayment}>
              <AddIcon />
            </IconButton>
          </Tooltip>
        </span>
      );
    },

    textLabels: {
      body: {
        noMatch: isLoading ? (
          <CircularProgress />
        ) : (
          "There is no matching data to display"
        ),
      },
    },
  };

  const ClientPaymentsOptions = {
    filter: true,
    rowsPerPage: 50,
    rowsPerPageOptions: [20, 50, 100],
    selectableRows: "none",

    customToolbar: () => {
      return (
        <span>
          <Tooltip title={"Add"}>
            <IconButton onClick={() => addPayment("in")}>
              <AddIcon />
            </IconButton>
          </Tooltip>
        </span>
      );
    },

    textLabels: {
      body: {
        noMatch: isLoading ? (
          <CircularProgress />
        ) : (
          "There is no matching data to display"
        ),
      },
    },
  };

  const workerPaymentsOptions = {
    filter: true,
    rowsPerPage: 50,
    rowsPerPageOptions: [20, 50, 100],
    selectableRows: "none",

    customToolbar: () => {
      return (
        <span>
          <Tooltip title={"Add"}>
            <IconButton onClick={() => addPayment("out")}>
              <AddIcon />
            </IconButton>
          </Tooltip>
        </span>
      );
    },

    textLabels: {
      body: {
        noMatch: isLoading ? (
          <CircularProgress />
        ) : (
          "There is no matching data to display"
        ),
      },
    },
  };

  const handleJobInputChange = (e) => {
    let { id, value, innerText, checked, type } = e.target;
    value = id.includes("option") ? innerText : value;
    id = id.includes("mui") ? "review_rate" : id;
    if (type === "checkbox") {
      setJobFormData((prev) => ({
        ...prev,
        [id]: checked ? 1 : 0,
      }));
    } else {
      setJobFormData((prev) => ({
        ...prev,
        [id]: value,
      }));
    }
  };
  const customJobOnChange = (newValue, name) => {
    setJobFormData((prev) => ({
      ...prev,
      [name]: newValue,
    }));
  };
  const [openFilterDialog, setOpenFilterDialog] = useState(false);
  const handleCloseFilter = () => {
    setOpenFilterDialog(false);
  };

  const filterListener = () => {
    setOpenFilterDialog(true);
  };
  const handleSaveFilter = () => {
    getData();

    handleCloseFilter();
  };

  const updatedVenders = venders.map((vender) => ({
    ...vender,
    description: `${vender.first_name} ${vender.last_name}`,
  }));
  const updatedCustomers = customers.map((vender) => ({
    ...vender,
    description: `${vender.first_name} ${vender.last_name}`,
  }));

  const noDealCauses = [
    { id: 1, name: "No answer twice" },
    { id: 2, name: "Only surging the web" },
    { id: 3, name: "Couldn't come asap - had to find someone else" },
    { id: 4, name: "Long distance" },
    { id: 5, name: "High price" },
    { id: 999, name: "Other" },
  ];

  const priorityList = [
    { id: 1, name: "No contact yet" },
    { id: 2, name: "Waiting for client response" },
    { id: 3, name: "Completed" },
  ];

  const giftOptions = [
    { id: 1, name: "Tree" },
    { id: 2, name: "Candle" },
    { id: 3, name: "Cleaning" },
  ];

  const selectedPriority = priorityList.find(
    (priority) => priority.id === jobFormData.priority
  );

  return (
    <AdminLayout>
      <div className="container">
        <JobsTable
          data={data}
          columns={columns}
          options={options}
          updateJobVisible={updateJobVisible}
          setUpdateJobVisible={setUpdateJobVisible}
          selectedJobId={selectedJobId}
          venders={venders}
          customers={customers}
          jobTypes={jobTypes}
          getData={getData}
        />
      </div>

      <StatusDialog
        statusVisible={statusVisible}
        handleCloseStatusModal={handleCloseStatusModal}
        statusData={statusData}
        statusColumns={statusColumns}
        statusOptions={statusOptions}
      />
      <StatusAddUpdateForm
        visible={visible}
        handleClose={handleClose}
        jobId={id}
        reloadStatuses={() => loadStatuses(null)}
      />
      <PaymentsDialog
        paymentsVisible={paymentsVisible}
        handleClosePaymentsModal={handleClosePaymentsModal}
        paymentsData={paymentsData}
        paymentsColumns={paymentsColumns}
        paymentsOptions={paymentsOptions}
      />
      <PaymentAddUpdateForm
        addUpdatePaymentVisible={addUpdatePaymentVisible}
        handleClose={handleCloseAddUpdatePayment}
        jobId={selectedJobId}
        paymentId={paymentId}
        paymentType={paymentType}
      />
      <WorkerProfileDialog
        visibleWorker={visibleWorker}
        handleCloseWorker={handleCloseWorker}
        formData={formData}
        selectedcategories={selectedcategories}
      />
      <CustomFilter
        filterForm={filterForm}
        handleChangeInputFilter={handleChangeInputFilter}
        handleclear={handleclear}
        openDialog={openFilterDialog}
        handleClose={handleCloseFilter}
        handleSave={handleSaveFilter}
      />
    </AdminLayout>
  );
};
export default AdminJobs;
